import {
  FilterHookArgumentsBase,
  FilterInternalArgumentsBase,
} from '@core/providers/filters'
import { localizedStrings } from '@core/strings'

export type AdvancedDueDateFilterOperators =
  | 'IS_DUE'
  | 'IS_DUE_IN_LESS_THAN'
  | 'HAS_NOT_BEEN_DONE'

export const advancedDueDateFilterOperatorsWithoutArguments: AdvancedDueDateFilterOperators[] =
  ['IS_DUE', 'HAS_NOT_BEEN_DONE']

export type AdvancedFilterOptionOperators = Array<{
  value: AdvancedDueDateFilterOperators
  label: string
}>

export type AdvancedDueDateFilterValue = {
  operator: AdvancedDueDateFilterOperators
  value?: number
}

export const advancedDueDateFilterValueIsPartial = (
  value: AdvancedDueDateFilterValue,
) => {
  if (!value?.operator) {
    return true
  }

  if (
    advancedDueDateFilterOperatorsWithoutArguments.includes(value?.operator)
  ) {
    return false
  }

  if (!value?.value) {
    return true
  }

  return false
}

export const advancedDueDateFilterOptionOperators: {
  value: AdvancedDueDateFilterOperators
  label: string
}[] = [
  { value: 'IS_DUE', label: localizedStrings.isDue },
  { value: 'IS_DUE_IN_LESS_THAN', label: localizedStrings.isDueInLessThan },
  { value: 'HAS_NOT_BEEN_DONE', label: localizedStrings.hasNotBeenDone },
]

export type AdvancedDueDateFilterHookArguments =
  FilterHookArgumentsBase<AdvancedDueDateFilterValue> & {
    advancedFilterOptionOperators?: AdvancedFilterOptionOperators
  }

export type AdvancedDueDateFilterInternalArguments<AdvancedDueDateFilterValue> =
  AdvancedDueDateFilterHookArguments &
    FilterInternalArgumentsBase<AdvancedDueDateFilterValue, 'ADVANCED_DUE_DATE'>

export const useAdvancedDueDateFilter = (
  filter: AdvancedDueDateFilterHookArguments,
): AdvancedDueDateFilterInternalArguments<AdvancedDueDateFilterValue> => {
  const nothingSelectedText =
    filter.nothingSelectedText || localizedStrings.noItemSelected

  const unfocusedText = (
    filterValue: AdvancedDueDateFilterValue,
    { noLabel } = { noLabel: false },
  ) => {
    const label = noLabel ? '' : `${filter.label}: `
    const value = filterValue?.value
    const operator = filterValue?.operator

    if (value || operator) {
      const operatorLabel = advancedDueDateFilterOptionOperators.find(
        (option) => option.value === operator,
      )?.label

      const filterValue = value ? ` ${value}` : ''

      return `${label} ${operatorLabel} ${filterValue}`
    }

    return `${label}${nothingSelectedText}`
  }

  return {
    ...filter,
    nothingSelectedText,
    type: 'ADVANCED_DUE_DATE',
    unfocusedText,
    serialization: 'object',
  }
}
